import '@fontsource/lato';
import '@fontsource/roboto';
import '@fontsource/roboto/500.css';
import '@fontsource/jetbrains-mono';
import { ThemeProvider } from '@mui/material';
import CssBaseline from '@mui/material/CssBaseline';
import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import './index.css';
import reportWebVitals from './reportWebVitals';
import MaterialTheme from './theme';

ReactDOM.render(
    <React.StrictMode>
        <CssBaseline enableColorScheme />
        <ThemeProvider theme={MaterialTheme}>
            <App />
        </ThemeProvider>
    </React.StrictMode>,
    document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
